import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationGR from './locales/gr/translation.json';
import translationIT from './locales/it/translation.json';
import translationRS from './locales/rs/translation.json';
import translationSP from './locales/sp/translation.json';
import translationEN from './locales/en/translation.json';

// Translation resources
const resources = {
  gr: { translation: translationGR }, // Greek
  it: { translation: translationIT }, // Italian
  rs: { translation: translationRS }, // Russian
  sp: { translation: translationSP }, // Spanish
  en: { translation: translationEN }  // English
};

i18n
  .use(detector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en", // Use English if the detected language is unavailable
    keySeparator: false, // Disable usage of dots in translation keys
    interpolation: {
      escapeValue: false // React already handles escaping
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'] // Cache user language preferences
    }
  });

export default i18n;
